export default "__VITE_ASSET__KbXQnqbC__"